import React, {createRef} from 'react'
import {findDOMNode} from "react-dom"

import Popover from "../../gd-popover/popover"
import HintPopover from "../../../gd-ui/hint-popover/hint-popover"

type Props = {
    className?              : string

    showToolbar?            : boolean
    hideToolbarAllowed      : boolean
    onChangeToolbarState?   : callback
}

export default class SettingsButton extends React.Component<Props> {

    hintPopover: any = createRef()

    static defaultProps = {
        showToolbar: true,
        hideToolbarAllowed: true,
    }

    state = {
        showPopover: false
    };

    showPopover =           () => {if (!this.state.showPopover) this.setState({showPopover: true}, ()=>this.hintPopover.current.hide())}
    hidePopover =           (callback?:any) => {if (this.state.showPopover) this.setState({showPopover: false}, ()=>{if (callback) callback()})}
    onChangeToolbarState =  () => {this.hidePopover(()=>{if (this.props.onChangeToolbarState) this.props.onChangeToolbarState(!this.props.showToolbar);});}
    onClickShortcuts =      () => {this.hidePopover(()=>{window.open(gd.utils.helpUrl('text.editor.shortcuts'));});}
    onClickHelp =           () => {this.hidePopover(()=>{window.open(gd.utils.helpUrl('text.editor'));});}

    renderPopover() {
        if (this.state.showPopover) {
            return (
                <Popover attachment="top center"
                         targetAttachment="bottom center"
                         attachmentType="horizontal"
                         onClickOutside={()=>{this.hidePopover()}}
                         getTargetFunc={()=>findDOMNode(this)}>

                    <div className="ui5-popover-menu">
                        {this.props.hideToolbarAllowed &&
                        <React.Fragment>
                            <div className="option" onClick={this.onChangeToolbarState}>
                                <div className="label">{this.props.showToolbar ? 'Hide toolbar' : 'Show toolbar'}</div>
                            </div>
                            <div className="separator"/>
                        </React.Fragment>}

                        <div className="option" onClick={this.onClickShortcuts}>
                            <div className="label">Shortcuts</div>
                        </div>
                        <div className="option" onClick={this.onClickHelp}>
                            <div className="label">Help</div>
                        </div>
                    </div>
                </Popover>
            );
        } else {
            return null;
        }
    }

    render() {
        const classes = Classes("gd-rich-editor-settings-button", "ui5-ico-more", "s20", this.props.className, {
            'show-popover': this.state.showPopover
        })

        return (
            <div className={classes} onClick={this.showPopover}>
                {this.renderPopover()}
                <HintPopover ref={this.hintPopover} parent={this} hint="More options" checkShowHint={()=>!this.state.showPopover}/>
            </div>
        )
    }
}